
import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL , 
  headers: {
    "Content-Type": "application/json",
  },
});

// Request Interceptor: Attach the token to every request
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token"); // Retrieve the token from localStorage
    if (token) {
      config.headers.Authorization = `Bearer ${token}`; // Attach the token to the Authorization header
    }
    return config;
  },
  (error) => {
    return Promise.reject(error); // Handle request errors
  }
);

// Response Interceptor: Handle global response errors (e.g., unauthorized access)
axiosInstance.interceptors.response.use(
  (response) => {
    return response; // Return the response as-is
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // Handle unauthorized access (e.g., redirect to login page)
      console.error("Unauthorized: Redirecting to login...");
      window.location.href = "/"; // Redirect to login page
    }
    return Promise.reject(error); // Propagate the error
  }
);

export default axiosInstance;